<div class="step-wrapper">
    <div class="description">
        Select one or more of your existing classes below, or
        <a
            href="/tools/rosters"
            (click)="activeModal.close()"
            target="_blank"
            rel="noopener noreferrer"
            >create a new class.</a
        >
        If you
        <a
            href="/tools/rosters"
            target="_blank"
            rel="noopener noreferrer"
            (click)="activeModal.close()"
            >import a class from Google Classroom</a
        >, you can see student progress in both PBS LearningMedia and Google Classroom.
    </div>
    <div class="classes-wrapper">
        <div class="class-row" *ngFor="let roster of rosters">
            <div class="class-check-box">
                <app-checkbox [type]="'hallow'" [(checked)]="roster.selected"></app-checkbox>
                <div class="class-name">{{ roster.rosterName }}</div>
                <img class="google-class" *ngIf="roster.rosterGoogleID" [src]="googleClassImg" />
            </div>
        </div>

        <div class="class-row" *ngIf="type === assignType.pbslm">
            <a
                href="/tools/rosters"
                target="_blank"
                rel="noopener noreferrer"
                (click)="activeModal.close()"
                >Create a new class</a
            >
        </div>

        <div class="class-row" *ngIf="type === assignType.google">
            <a
                href="/tools/rosters"
                target="_blank"
                rel="noopener noreferrer"
                (click)="activeModal.close()"
                >Import class from Google Classroom</a
            >
        </div>
    </div>
    <div class="buttons-wrapper">
        <app-button (click)="goBack()" [buttonClasses]="'hallow'">Go Back</app-button>
        <app-button (click)="next()" [disable]="!checkIfSelected()" [buttonClasses]="'hallow'"
            >Next: Select Students</app-button
        >
    </div>
</div>
